/* istanbul ignore file  */
export enum SidesheetComponentOptions {
    None = 1,
    MapContextLayerForm = 2,
    LogicBuilderForm = 3,
    MapFieldPointForm = 4,
    FeedbackForm = 5,
    SiteActivityLogGrid = 6,
    WidgetConfigurationForm = 7,
    ReportDefinitionForm = 8
}
